/**
 * Builds the DOM id for the all-day header — the lowest sticky element above the
 * time grid. Its bottom edge marks where the stacked sticky headers end, which
 * is the offset the start hour must clear. Scoped by the view's test id to stay
 * unique per calendar instance. Single source of truth for set + lookup.
 */
export function getAllDayHeaderElementId(testId: string): string {
  return `${testId}-all-day-header`;
}
